/**
 * Возвращает текущий период в формате YYYY-MM.
 */
export function getCurrentPeriod(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
}

/**
 * Форматирует период YYYY-MM в читаемый вид: «Июнь 2026».
 */
export function formatPeriod(period: string): string {
  const [year, month] = period.split('-');
  const date = new Date(Number(year), Number(month) - 1, 1);
  return date.toLocaleDateString('ru-RU', { month: 'long', year: 'numeric' });
}

/**
 * Форматирует дату ISO в читаемый вид: «19.06.2026».
 */
export function formatDate(dateStr: string): string {
  const date = new Date(dateStr);
  return date.toLocaleDateString('ru-RU');
}

/**
 * Возвращает сегодняшнюю дату в формате YYYY-MM-DD.
 */
export function todayIso(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Проверяет, открыто ли окно корректировки (20-25 число).
 */
export function isCorrectionWindowOpen(): boolean {
  const day = new Date().getDate();
  return day >= 20 && day <= 25;
}
